import React, { useContext } from "react";
import { WizardContext } from "../index";

export default function Header({ title }) {
  const { resetState } = useContext(WizardContext);
  return (
    <div className="modal-header">
      <h4>{title}</h4>
      <a
        onClick={() => {
          handlePopupClose();
        }}
        className="button-close"
      >
        Close
      </a>
    </div>
  );
}
